<div class="game-banner ticket-transfer-banner" role="banner">
  <h1>{{ 'ticket.transfer.page.banner.text' | translate }}</h1>
</div>

<div class="container mt-4">
  <div class="row">
    <div class="col-8 text-black">
      <h4>{{ 'ticket.transfer.page.header' | translate }}</h4>
      <p>
        {{ 'ticket.transfer.page.header.text' | translate }}
      </p>
    </div>
    <div class="col-4">
      <button [routerLink]="['/contacts']" class="btn btn-primary contacts-management-button float-right">
        MANAGE MY CONTACTS
        <span class="icon material-icons float-right contacts-management-button-icon">arrow_forward_ios</span>
      </button>
    </div>
  </div>
  <h4 class="games-title mt-3 mb-4 text-black">Home Games</h4>
  <fgbcl-games-list-with-tickets></fgbcl-games-list-with-tickets>

  <div class="row">
    <h4 class="games-title mt-3 mb-4 text-black col-9">Past Home Games</h4>
    <div class="float-right col-3 mt-3">
      <span *ngIf="showPastGames" class="icon material-icons float-right display-past-games-icon" (click)="togglePastGames()"
        >expand_less</span
      >
      <span *ngIf="!showPastGames" class="icon material-icons float-right display-past-games-icon" (click)="togglePastGames()"
        >expand_more</span
      >
    </div>
  </div>
  <div *ngIf="showPastGames">
    <fgbcl-games-list-with-tickets [showPastGamesOnly]="true"></fgbcl-games-list-with-tickets>
  </div>
</div>
